export const SELECTED_ORG_ID = 'selectedOrganisationId';
export const SELECTED_ORG_NAME = 'selectedOrganisationName';
/** Comma-separated org IDs, most recently viewed first (max 10). */
export const RECENT_ORG_IDS = 'recentOrganisationIds';
/** JSON array of society objects from the public /search hero (max 5). */
export const RECENTLY_VIEWED_ORGS = 'recentlyViewedOrgs';
